export const TRANSLATIONS_ES = {
  All: "Todo",
  Dry: "Seco",
  Dryingout: "secarse",
  Healthy: "Saludable",
  Manual: "Manual",
  Menu: "Menú",
  Midphase: "Fase de madurez",
  Oldphase: "Fase de envejecimiento",
  Profile: "Perfil",
  Set_the_report_of_the_project_with_the_help_of_the_pin:
    "Establecer el informe del proyecto con la ayuda del pin.",
  Unknown: "Desconocido",
  Wet: "Húmedo",
  Youngphase: "Fase juvenil",
  account_type: "Tipo de cuenta",
  action: "Acción",
  action_priority: "Prioridad de acción",
  action_required: "Acción requerida",
  actions: "Comportamiento",
  active: "activo",
  active_installation: "Instalación activa",
  active_sensor_installation: "Instalación de sensores activos",
  add: "Agregar",
  addTree: "Agregar árbol",
  add_all_form: {
    area: {
      existing_area: "Elija un área existente",
      explanation:
        "¿Quiere agregar el Árbol a un Área existente o desea crear un Área y agregarle el Árbol?",
      new_area: "Crear una nueva área",
      title: "Área",
    },
    no_photos: "No se subieron fotos",
    sensor: {
      existing_sensors: "Elija sensores existentes",
      explanation: "¿Quieres agregar un sensor a un árbol existente o quieres crear uno nuevo?",
      new_sensor: "Agregar un nuevo sensor",
      title: "Sensor",
    },
    title: "Agregar árbol con sensor en el área",
    traffic_safety: "Seguridad",
    tree: {
      existing_tree: "Elija un árbol existente",
      explanation:
        "¿Desea agregar un árbol existente o desea crear uno nuevo? Aquí puede agregar un nuevo sensor y dem Baum hinzugefügt werden. Oder aber ein bereits bestehender Sensor cann ausgewählt werden, um ihn dem hinzuzufügen.",
      new_tree: "Crear un nuevo árbol",
      title: "Árbol",
    },
    tree_info: "Información del árbol",
  },
  add_area: "Agregar área",
  add_assessment: "Agregar evaluación",
  add_child_tree: "Agregar árbol hijo",
  add_comment: "Añadir comentario",
  add_existing_tree: "Agregar árbol existente",
  add_inspection: "Agregar inspección",
  add_installation: "Agregar instalación",
  add_photo: "Agregar foto",
  add_safety_assessment: "Agregar evaluación de seguridad",
  add_sensor: "Agregar sensor",
  add_task: "Agregar tarea",
  add_tree_img: "Agregar imagen de árbol",
  add_user: "Agregar usuario",
  add_vta: "Agregar evaluación VTA",
  add_your_own_maintenance: "Añade tu propio mantenimiento",
  address: "DIRECCIÓN",
  adjust_thresholds_crown: "Ajustar los umbrales para los sensores de la corona",
  adjust_thresholds_soil: "Ajustar los umbrales para los sensores de suelo",
  admin: "Administración",
  aim: "Objetivo del proyecto",
  aim_irrigation_demand_determination: "Determinación de la demanda de riego",
  alerts: "Alertas",
  align_qr_code_within_the_frame: "Alinear el código QR dentro del marco",
  all_areas: "Todas las áreas",
  all_projects: "Todos los proyectos",
  all_responsible: "Todos responsables",
  all_species: "Todas las especies",
  all_trees: "Todos los árboles",
  already_have_an_account: "¿Ya tienes una cuenta?",
  altitude: "Altitud",
  amount_nodes: "Cantidad de nodos sensores",
  api_documentation: "Documentación API",
  appearance: "Apariencia",
  area: "Área",
  areaName: "Nombre",
  area_form: {
    existing_area: "Área existente",
  },
  area_management: "Gestión de Área",
  areas: "Áreas",
  assessment_date: "Fecha de evaluación",
  assessor: "Asesor",
  assign_to_tree: "Asignar al árbol",
  back: "Atrás",
  back_to_login: "Volver a iniciar sesión",
  activate_account: "Activar cuenta",
  activating_account: "Activando tu cuenta...",
  activation_success: "Cuenta activada con éxito!",
  activation_success_message: "Tu cuenta ha sido activada con éxito. Ahora puedes iniciar sesión.",
  activation_failed: "Error de activación",
  bark_condition: {
    healthy: "Saludable",
    minor_damage: "Daños menores",
    moderate_damage: "Daño moderado",
    severe_damage: "Daño severo",
  },
  bark_condition_label: "Condición de la corteza",
  basic: "Básico",
  basic_user_areas_hint:
    "A los usuarios básicos se les debe asignar una o más áreas/ubicaciones. Sin asignaciones, sus datos accesibles son limitados.",
  basic_user_projects_hint:
    "Puedes asignar proyectos completos aquí. Se incluirán todas las ubicaciones/áreas pertenecientes a los proyectos seleccionados.",
  battery: "Batería",
  battery_empty: "Batería vacía",
  battery_full: "Batería llena",
  battery_is_getting_low: "La batería se está agotando",
  beta_ended: {
    description:
      "¡Gracias por usar la versión beta! Todos los cambios y mejoras de la fase beta se han implementado y ahora están disponibles en TreeSense Cloud.",
    link_text: "Ir a la nube TreeSense",
    subtitle: "La fase de prueba ha terminado.",
    title: "Fase Beta finalizada",
  },
  button: {
    add_all: "Agregar árbol con componentes",
    add_customer: "Agregar cliente",
    add_irrigation_area: "Agregar área de riego",
    add_sensor: "Agregar sensor",
    add_tree: "Agregar árbol",
    back: "Atrás",
    cancel: "Cancelar",
    edit_customer: "Editar cliente",
    import_tree: "Importar árbol",
    next: "Próximo",
    reset: "Reiniciar",
    save: "Ahorrar",
    saving: "Guardando...",
    update: "Actualizar",
    updating: "Actualizando...",
  },
  calculated_values_wip:
    "Los valores calculados (moisture_content, resis_temp_comp) aún están en progreso. Úselos con precaución. Seleccione si desea descargar también los valores calculados.",
  calibration_species: "Especies de calibración",
  calibration_species_legacy_settings_hint:
    "Se está utilizando la calibración heredada de álamo negro.",
  calibration_species_no_mapping: "No hay mapas de especies disponibles",
  calibration_species_settings_hint:
    "Si no se muestra ningún mapeo aquí o la fórmula heredada aún está activa, esto se puede actualizar en Configuración > Cliente > Fórmula de contenido de humedad.",
  calibration_species_settings_link: "Abrir configuración",
  calibration_species_tooltip:
    "El modelo de calibración utilizado para esta especie para calcular el índice de humedad.",
  calibration_species_unknown_tree_species: "Faltan especies de árboles",
  cancel: "Cancelar",
  optional: "opcional",
  export_irrigation_tasks: "Exportar tareas de riego",
  export_irrigation_tasks_short: "Exportar",
  export_irrigation_tasks_description_v2:
    "Exportar el plan de riego a Excel para un responsable específico. Muestra todos los riegos de la temporada de vegetación actual (abril - octubre).",
  export_filter_assignee_hint: "Dejar vacío para exportar tareas de todos los responsables",
  no_irrigation_tasks_found:
    "No se encontraron tareas de riego para los filtros seleccionados. Por favor, compruebe el responsable y el período.",
  tree_number: "Nº de árbol",
  sensor_installed: "Sensor instalado",
  responsible_person: "Responsable",
  irrigation_abbrev: "Rieg.",
  irrigation_plan: "Plan de riego",
  represented_trees: "Árboles a regar conjuntamente",
  card_name: "Nombre de la tarjeta",
  card_number: "Número de tarjeta",
  care_chat: {
    action_required: "Acción requerida",
    add_entry: "Agregar entrada",
    add_photo: "Añadir foto",
    all_priorities: "Todas las prioridades",
    all_statuses: "Todos los estados",
    all_types: "Todos los tipos",
    amount: "Cantidad:",
    appointment_label: "Cita:",
    assignment: "Asignación",
    assignment_display: "Asignación:",
    attachment_display: "Adjunto:",
    back: "Atrás",
    cancel: "Cancelar",
    completion: "Terminación",
    consult_specialist: "Consulta con departamento especializado.",
    cost_center: "centro de costos",
    cost_center_display: "Centro de costos:",
    cut_type: "Tipo de corte:",
    date: "Fecha",
    datetime: "Fecha y hora",
    datetime_display: "Fecha/Hora:",
    deadline: "Fecha límite:",
    delete: "Borrar",
    description: "Descripción",
    description_display: "Descripción:",
    detailed_investigation: "Investigaciones detalladas",
    edit: "Editar",
    executor: "Ejecutor:",
    favorite: "Favorito",
    felling: "tala",
    fill_checklist: "Llenar lista de verificación",
    fill_form: "Rellenar formulario",
    fill_protocol: "Protocolo de llenado",
    finding: "Descubrimiento:",
    follow_up_inspection: "Inspección periódica (seguimiento)",
    further_action_title: "Acciones adicionales",
    future_date_required: "Elija una fecha y hora futuras.",
    immediately: "inmediatamente",
    in_days: "In {{days}} days",
    in_hours: "In {{hours}} hrs.",
    in_one_month: "en un mes",
    in_one_week: "en una semana",
    inspected_by: "Inspeccionado por",
    inspected_by_display: "Inspeccionado por:",
    inspection_data: "Datos de inspección",
    inspection_date_display: "Fecha de inspección:",
    inspection_intervals: "Intervalos de inspección",
    inspection_level: "Nivel de inspección:",
    inspection_title: "Inspección periódica de documentos",
    interval_as_before: "como antes",
    interval_display: "Intervalo:",
    interval_future_every: "en el futuro cada",
    interval_years: "Intervalo (años)",
    interval_years_annual: "años / anualmente",
    irrigation_log_title: "Protocolo de riego",
    irrigation_method: "Método de riego",
    irrigation_method_display: "Método de riego:",
    irrigation_method_placeholder: "p.ej. manual, bolsa de riego, cisterna",
    irrigation_protocol_title: "Protocolo de riego de llenado",
    mark_done: "Marcar como hecho",
    mark_not_done: "Marcar como no hecho",
    measure_free: "Entrada gratuita",
    measure_inspection: "Inspección periódica",
    measure_irrigation: "Riego",
    measure_pruning: "Medida de poda",
    method: "Método:",
    next_inspection: "Próxima inspección",
    next_inspection_display: "Próxima inspección:",
    next_inspection_label: "Próxima inspección:",
    no: "No",
    no_entries_found: "No se encontraron entradas.",
    no_inspection_planned: "No se prevé ninguna inspección.",
    no_tasks_found: "No se encontraron tareas.",
    overdue_since_days: "Overdue for {{days}} days",
    overdue_since_hours: "Overdue for {{hours}} hrs.",
    perform_inspection: "Realizar inspección",
    plan_inspection: "Inspección de planos",
    please_provide_tree_condition: "Por favor proporcione la condición del árbol.",
    please_provide_type: "Por favor proporcione un tipo.",
    please_select_person: "Por favor seleccione una persona.",
    priority: "Prioridad",
    priority_critical: "Crítico",
    priority_high: "Alto",
    priority_low: "Bajo",
    priority_medium: "Medio",
    pruning_clearing: "Limpieza / tala libre",
    pruning_crown_reduction: "Reducción de corona / cuidado de la corona",
    pruning_formative: "Poda formativa",
    pruning_log_title: "Protocolo de poda",
    pruning_maintenance: "Poda de mantenimiento",
    pruning_protocol_title: "Protocolo de poda de relleno",
    pruning_remedial: "Poda de recuperación (restauradora/correctiva)",
    pruning_safety: "Poda de seguridad (poda de seguridad vial)",
    pruning_type: "Tipo de medida de poda",
    pruning_type_display: "Tipo:",
    pruning_type_required: "Tipo de medida de poda (obligatoria)",
    reason: "Motivo/ocasión",
    reason_display: "Razón:",
    reason_label: "Motivo/ocasión:",
    reason_placeholder: "regular, sequía, ...",
    recommendation: "Recomendación:",
    remark_display: "Observación:",
    remark_optional: "Observación (opcional)",
    remarks: "Observaciones",
    remarks_display: "Observaciones:",
    remarks_label: "Observaciones",
    remove: "Eliminar",
    reschedule: "Reprogramar",
    reschedule_title: "Reprogramar cita",
    responsible_person: "persona responsable",
    responsible_person_display: "Persona responsable:",
    responsible_person_required: "Persona responsable (requerido)",
    road_safe: "Carretera segura",
    road_safe_display: "Seguridad en la carretera:",
    save: "Ahorrar",
    scope: "Alcance:",
    select_placeholder: "Seleccionar",
    sensor_install_task: "Montar el sensor en el árbol",
    sensor_maintenance_task: "Realizar mantenimiento del sensor en el árbol.",
    short_description_optional: "Breve descripción (opcional)",
    short_description_placeholder: "Breve descripción",
    show_less: "Mostrar menos",
    show_more: "Mostrar más",
    soil_dry: "seco",
    soil_moisture: "Humedad del suelo",
    soil_moisture_display: "Humedad del suelo:",
    soil_slightly_moist: "ligeramente húmedo",
    soil_wet: "húmedo",
    sort_by_date: "Ordenar por fecha",
    sort_by_priority: "Ordenar por prioridad",
    status_commissioned: "Oficial",
    status_done: "Hecho",
    status_in_progress: "En curso",
    status_not_done: "No hecho",
    status_planned: "Planificado",
    time: "Tiempo",
    today: "Hoy",
    tomorrow: "Mañana",
    tree_care_measures: "Medidas para el cuidado de los árboles.",
    tree_care_measures_hint:
      "p.ej. eliminación de madera muerta, poda de limpieza, estabilización de copas",
    tree_condition: "Condición del árbol",
    tree_condition_damage: "daño",
    tree_condition_display: "Estado del árbol:",
    tree_condition_healthy: "saludable",
    tree_condition_other: "otro",
    tree_condition_placeholder: "p.ej. sano, daño, infección por hongos",
    tree_condition_required: "Condición del árbol (requerido)",
    tree_condition_tilt: "inclinación",
    tree_condition_wilted_leaves: "hojas marchitas",
    upload_document: "Subir documento",
    upload_document_hint: "Suelte PDF, imagen o documento aquí, o haga clic para seleccionar",
    water_amount_display: "Cantidad de agua:",
    water_amount_liters: "Cantidad de agua (litros)",
    water_amount_required: "Por favor ingrese la cantidad de agua.",
    weather_cloudy: "nublado",
    weather_conditions: "Condiciones climáticas",
    weather_display: "Condiciones climáticas:",
    weather_dry: "seco",
    weather_rain_after: "lluvia después",
    weather_rain_before: "lluvia antes",
    weather_sunny: "soleado",
    weather_windy: "ventoso",
    weeks: "semanas",
    within: "dentro",
    yes: "Sí",
  },
  challenges: "Problemas durante el proyecto / Desafíos futuros",
  challenges_placeholder: "¿Qué problemas ocurrieron? ¿Qué necesitaba el cliente?",
  change: "Cambiar",
  change_image: "Cambiar imagen",
  change_language: "Cambiar idioma",
  change_logo: "Cambiar logotipo",
  change_position: "Cambiar de posición",
  characters: "Personajes",
  childTree: "árbol infantil",
  child_trees: "árboles infantiles",
  choose_file: "Elija archivo",
  choose_location: "Elige Ubicación",
  choose_project: "Elige un proyecto",
  choose_qr_to_scan: "Elija QR para escanear",
  choose_the_file_to_be_imported: "Elija el archivo a importar",
  choose_tree: "Elige árbol",
  city: "Ciudad",
  clear: "Claro",
  clear_filter: "Borrar filtro",
  clearance_profile_pruning: "Poda de perfil de liquidación",
  click_on_marker_to_select_tree: "Haga clic en el marcador para seleccionar el árbol",
  cloase_area_list: "Cerrar lista de áreas",
  close: "Cerca",
  close_areas_list: "Lista de áreas cercanas",
  close_overlays: "Cerrar superposiciones",
  close_sidebar: "Cerrar barra lateral",
  close_time_controls: "Cerrar controles de tiempo",
  completed: "Terminado",
  condition_reports: "Informes de condición",
  confirm: "Confirmar",
  confirm_delete: "Confirmar eliminación",
  confirm_delete_image: "¿Estás seguro de que deseas eliminar esta imagen?",
  confirm_delete_task_message: "¿Estás seguro de que deseas eliminar esta tarea?",
  continue: "Continuar",
  cookie_consent: {
    accept_all: "Aceptar todo",
    accept_essential: "Sólo esencial",
    analytics_cookies: "Cookies analíticas",
    analytics_cookies_description:
      "Estas cookies nos permiten contar visitas y fuentes de tráfico para que podamos medir y mejorar el rendimiento de nuestro sitio web. Nos ayudan a comprender qué páginas son las más populares y cómo se mueven los visitantes por el sitio.",
    banner_description:
      "Utilizamos cookies para brindarle la mejor experiencia posible en nuestro sitio web. Puedes personalizar tus preferencias o aceptar todas las cookies.",
    banner_title: "Configuración de cookies",
    cookie_policy: "Política de cookies",
    customize: "Personalizar",
    essential_cookies: "Galletas esenciales",
    essential_cookies_description:
      "Estas cookies son esenciales para que el sitio web funcione y no se pueden desactivar. Por lo general, solo se configuran en respuesta a acciones que usted realiza, como configurar sus preferencias de privacidad, iniciar sesión o completar formularios.",
    last_updated: "Última actualización",
    marketing_cookies: "Galletas de marketing",
    marketing_cookies_description:
      "Estas cookies pueden ser configuradas por nuestros socios publicitarios a través de nuestro sitio web. Pueden utilizarse para crear un perfil de sus intereses y mostrarle publicidad relevante en otros sitios web.",
    preferences_cookies: "Cookies de preferencia",
    preferences_cookies_description:
      "Estas cookies permiten que el sitio web recuerde sus elecciones (como su nombre de usuario, idioma o región) y proporcione funciones mejoradas y más personalizadas.",
    preferences_error: "Error al guardar las preferencias.",
    preferences_saved: "Se han guardado sus preferencias de cookies.",
    privacy_policy: "política de privacidad",
    save_preferences: "Guardar preferencias",
    settings_description:
      "Administre sus preferencias de cookies. Los cambios entrarán en vigor inmediatamente.",
    settings_title: "Configuración de cookies",
  },
  cost_analysis: "Análisis de costos",
  country: "País",
  create_account: "Crear una cuenta",
  create_customer: "Crear cliente",
  create_new_tree: "Crear nuevo árbol",
  create_task: "Crear tarea",
  creating: "creando",
  critical: "Crítico",
  critical_sensors: "Número total de sensores críticos",
  crown: "Corona",
  crown_care: "Cuidado de la corona",
  crown_defects: "Defectos de la corona",
  crown_diameter: "Diámetro de la corona",
  crown_vitality: "Vitalidad de la corona",
  current_theme: "Tema actual",
  custom_maintenance_type: "Tipo de mantenimiento personalizado",
  custom_range: "Rango",
  custom_range_info: "Seleccione un rango de fecha y hora personalizado",
  customer: "Cliente",
  customer_attributes: "Atributos del cliente",
  customer_creation_code: "Código de creación de cliente",
  customer_name: "Nombre del cliente",
  customer_statistics_description: "Ver estadísticas de clientes y descripción general de datos",
  customer_type: "Tipo de cliente",
  customer_type_agriculture: "Agricultura",
  customer_type_city: "Ciudad",
  customer_type_forestry: "Silvicultura",
  customer_type_science: "Ciencia",
  customers: "Clientes",
  daily_changes_email: "Correo electrónico de cambios diarios",
  damage_severity: {
    critical: "Crítico",
    light: "Luz",
    moderate: "Moderado",
    none: "Ninguno",
    severe: "Severo",
  },
  damage_severity_label: "Gravedad del daño",
  dashboard: {
    all_locations: "Todas las ubicaciones",
    avg_age: "Edad media de los árboles",
    avg_crown_diameter: "Diámetro medio de la corona",
    avg_height: "Altura promedio de los árboles",
    avg_trunk_diameter: "Diámetro medio del tronco",
    data_status: "Estado de los datos",
    greeting: "Hola",
    group_biometrics: "Biometría de árboles",
    group_inventory: "Inventario de árboles",
    group_recommendations: "Recomendaciones",
    group_sensors: "Estado del sensor",
    health_last_30_days: "Salud últimos 30 días",
    health_overview: "Descripción general",
    kpi_avg_age: "Edad promedio",
    kpi_avg_crown_diameter: "Diámetro medio de la corona",
    kpi_avg_height: "Altura media",
    kpi_avg_trunk_circumference: "Circunferencia media del tronco",
    kpi_critical_sensors: "Sensores críticos",
    kpi_disconnected_sensors: "Sensores desconectados (últimas 3 horas)",
    kpi_maintenance_sensors: "Lecturas de sensores inverosímiles",
    kpi_recommended_actions: "Árboles con acción recomendada",
    kpi_sensor_types: "Tipos de sensores",
    kpi_total_sensors: "Número de sensores",
    kpi_total_species: "Número de especies de árboles",
    kpi_total_trees: "Número de árboles",
    last_30_days: "últimos 30 días",
    last_3_hours: "últimas 3 horas",
    no_data: "No hay datos disponibles",
    no_health_data: "No hay datos de salud disponibles",
    sensor_types: "Tipos de sensores",
    tasks_by_due_period: "Tareas por plazo",
    title: "Panel",
    top_species: "Las 5 principales especies de árboles",
    top_species_info_body:
      "Muestra las especies de árboles más frecuentes en los filtros actuales. Los valores se basan en el recuento de árboles por especie.",
    top_species_info_title: "Las 5 principales especies de árboles",
    tree_health: "Salud de los árboles",
    view_sensors: "Ver sensores",
    view_tasks: "Tareas abiertas",
    view_trees: "Ver árboles",
    overview: "Resumen",
    years_short: "años",
  },
  dashboards: "Paneles",
  esg: {
    title: "Monitoreo ESG",
    subtitle: "Eficiencia de recursos",
    reporting_scope: "Alcance del informe",
    generate_pdf: "Generar PDF",
    export_csv: "Exportar CSV",
    data_quality: "Calidad de datos",
    completed_irrigation_volume: "Volumen de riego completado",
    estimated_water_saved: "Ahorro de agua estimado",
    irrigation_efficiency: "Eficiencia de riego",
    estimated_co2_avoided: "CO2 evitado estimado",
    liters: "litros",
    measured: "Medido",
    estimated: "Estimado",
    derived: "Derivado",
    vs_last_period: "vs período anterior",
    irrigation_analysis: "Análisis de riego",
    monthly_comparison: "Comparación mensual: Línea base estimada vs. riego completado",
    monthly_comparison_through_current_month: "Comparación mensual hasta el mes actual inclusive",
    baseline: "Línea base",
    completed: "Completado",
    water_saved: "Agua ahorrada",
    methodology: "Metodología",
    calculation_basis: "Base de cálculo",
    data_coverage: "Cobertura de datos",
    included_assumptions: "Supuestos incluidos",
    exclusions: "Exclusiones y datos faltantes",
    all_projects: "Todos los proyectos",
    all_areas: "Todas las áreas",
    disclaimer_title: "Aviso legal",
    retry: "Reintentar",
    // Metodología – Base de cálculo
    calc_volume_source:
      "El volumen de riego completado se obtiene de las tareas de riego completadas y documentadas.",
    calc_baseline_profile:
      "El riego de línea base utiliza perfiles de cuidado predeterminados de TreeSense basados en la edad del árbol (año de plantación).",
    calc_seasonal_weighting:
      "La línea base mensual se distribuye mediante un perfil de ponderación estacional concentrado en la temporada de riego de abr–sep.",
    calc_water_saved:
      "Agua ahorrada = línea base menos volumen de riego completado, limitado a ≥ 0.",
    calc_co2_explanation:
      "El CO₂e evitado estimado se calcula en dos pasos. Primero, el ahorro de agua estimado se convierte en demanda eléctrica evitada utilizando la intensidad energética asumida del sistema hídrico. El ahorro eléctrico resultante se multiplica entonces por el factor de emisión eléctrica.",
    calc_co2_formula:
      "CO₂e evitado estimado = Agua ahorrada (m³) × Intensidad energética del sistema hídrico (kWh/m³) × Factor de emisión eléctrica (kg CO₂e/kWh)",
    // Metodología – Supuestos incluidos
    assumption_young_0_1: "Árbol joven año 0–1: 3.000 l/año (20 riegos × 150 l)",
    assumption_young_2_3: "Árbol joven años 2–3: 1.800 l/año (12 riegos × 150 l)",
    assumption_years_4_7: "Años 4–7: 750 l/año (5 riegos × 150 l)",
    assumption_established:
      "Árboles establecidos (>7 años): sin línea base modelada en esta primera versión metodológica (no equivale a necesidad de riego cero).",
    assumption_energy_intensity:
      "Intensidad energética del sistema hídrico: 0,5 kWh/m³ (suposición interna de primer borrador; aún no validada con datos de servicios públicos locales).",
    assumption_emission_factor:
      "Factor de emisión eléctrica: 0,4 kg CO₂e/kWh (suposición interna de primer borrador; destinado a ser reemplazado por un factor específico por año de reporte y geografía).",
    assumption_seasonal:
      "Ponderación estacional: la línea base está fuertemente concentrada en abr–sep (~76%), con una pequeña ponderación residual fuera de la temporada alta.",
    // Metodología – Exclusiones
    exclusion_missing_planting_year:
      "{{count}} registro(s) de árboles excluido(s) de la línea base por falta de año de plantación.",
    exclusion_large_transplant:
      "La línea base de trasplantes grandes aún no está modelada por separado (sin campo de identificación fiable).",
    exclusion_no_volume: "Los registros de tareas sin volumen extraíble se ignoran.",
    // Metodología – Aviso legal
    disclaimer_text:
      "El volumen de riego completado se basa en los registros de riego documentados en litros en la plataforma TreeSense. El agua ahorrada y el CO₂ evitado son valores estimados calculados mediante metodologías y supuestos estandarizados.",
    // Calidad de datos
    quality_good: "Buena",
    quality_partial: "Parcial",
    quality_insufficient: "Insuficiente",
    methodology_details: "Detalles de la metodología",
    methodology_version: "Versión",
    methodology_updated: "Actualizado",
    methodology_first_draft: "Actualizado: primer borrador",
    // Metodología – Referencias
    references: "Referencias",
    references_explanation:
      "El GHG Protocol se utiliza como base metodológica para convertir datos de actividad y uso de electricidad en emisiones de gases de efecto invernadero. La conversión agua-energía de TreeSense y los factores numéricos utilizados actualmente son suposiciones internas de primer borrador.",
    ref_corporate_standard: "GHG Protocol Corporate Standard",
    ref_scope2_guidance: "GHG Protocol Scope 2 Guidance",
    without_project_not_supported:
      "El monitoreo ESG aún no está disponible para árboles sin proyecto. Seleccione un proyecto o Todos los proyectos para ver el panel.",
    year: "Año",
    area: "Área",
  },
  data_analysis: "Análisis de datos",
  data_graphs: "Datos y gráficos",
  data_interval_description: "Especifique cómo se deben agrupar los puntos de datos en el gráfico.",
  data_interval_settings: "Configuración del intervalo de datos",
  data_science: "Ciencia de datos",
  data_status: "Estado de los datos",
  date: "Fecha",
  date_time: "Fecha/Hora",
  datetime_photo: "Hora de captura de la imagen",
  day: {
    fri: "Viernes",
    mon: "Lunes",
    sat: "Sábado",
    sun: "Domingo",
    thu: "Jueves",
    tue: "Martes",
    wed: "Miércoles",
  },
  day_friday: "Vie",
  day_monday: "Lun",
  day_saturday: "Se sentó",
  day_sunday: "Sol",
  day_thursday: "Jue",
  day_tuesday: "Mar",
  day_wednesday: "Casarse",
  days: "Días",
  days_left: "quedan días",
  deadwood_removal: "Eliminación de madera muerta",
  default: "Por defecto",
  default_legacy: "Predeterminado, heredado",
  default_liters: "Litros predeterminados",
  defect: "Defecto",
  defect_sensor: "Sensor de defecto presente",
  defect_sensors_excluded: "Los sensores defectuosos están excluidos del cálculo.",
  defect_sensors_info:
    "Los sensores defectuosos o inalcanzables (que se muestran en gris) no se consideran en el cálculo de estado. Sólo los sensores que funcionan contribuyen al estado.",
  defect_types: "Tipos de defectos",
  delete: "Borrar",
  delete_task: "Borrar",
  demo_project_warning: {
    description:
      "Actualmente estás utilizando una cuenta de demostración y tienes permisos limitados.\nSi ya es cliente y desea acceder a su cuenta de cliente, comuníquese con el soporte: support@treesense.net.\nSi aún no es cliente, puede solicitar sensores a través de nuestra tienda en https://www.treesense.net",
    title: "Cuenta demo",
  },
  dendrometer: "dendrómetro",
  dendrometer_sensor: "Sensor dendrómetro",
  tilt_sensor: "Sensor de inclinación",
  roll: "Balanceo",
  pitch: "Cabeceo",
  tilt_roll: "Ángulo de balanceo",
  tilt_pitch: "Ángulo de cabeceo",
  tilt_threshold: "Umbral de inclinación",
  tilt_alarm: "Alarma de inclinación",
  tilt_alarm_active: "Activo",
  tilt_alarm_inactive: "Sin alarma",
  tilt_alarm_email: "Email de alarma de inclinación",
  task_notification_email: "Email de asignación de tarea",
  tilt_calibrate: "Poner a cero",
  calibrating: "Calibrando...",
  tilt_calibrate_confirm: "¿Establecer la posición actual como punto cero?",
  depth: "Profundidad",
  description: "Descripción del proyecto",
  description_placeholder: "Describe brevemente el proyecto.",
  deselect_all: "Deseleccionar todo",
  dev_eui: "DevEUI",
  development_phase: "Fase de desarrollo",
  development_trends: "Tendencias de desarrollo",
  diameter: "Diámetro",
  diameter_minus_start: "Cambio de diámetro desde el inicio.",
  dieback: "Muerte regresiva",
  disconnected_sensors: "Sensores desconectados",
  documents: "Documentos",
  dont_have_an_account: "¿No tienes una cuenta?",
  download: "Descargar",
  download_csv: "Descargar CSV",
  download_excel: "Descargar Excel",
  download_pdf: "Descargar PDF",
  download_project_csv: "Descargar datos del proyecto (archivos TSV)",
  download_project_data: "Descargue todos los datos de los sensores para este proyecto",
  download_sensor_data: "Descargar datos de sensores",
  download_successful: "Descarga exitosa",
  download_tree_details: "Descargar Detalles de Árboles (.pdf)",
  download_tree_list: "Descargar lista de árbol (.xlsx)",
  downloading: "Descargando…",
  drag_the_below_variables_to_graph_area: "Arrastre las siguientes variables para graficar el área",
  drop_left: "Soltar a la izquierda",
  drop_right: "Caer a la derecha",
  drop_the_variable_to_get_data: "Suelta la variable. ¡Seguir!",
  drought_days: "Días de sequía",
  ds_enter_fullscreen: "Modo de enfoque",
  ds_exit_fullscreen: "Salir del modo de enfoque",
  ds_fetch_error_hint:
    "Reduzca el intervalo de fechas, seleccione menos sensores o vuelva a intentarlo.",
  ds_fetch_error_message:
    "No se pudieron cargar los datos de la serie temporal seleccionados. El rango de tiempo seleccionado o el número de sensores pueden ser demasiado grandes.",
  ds_no_data_hint: "No se encontraron valores para los filtros y el rango de tiempo seleccionados.",
  ds_no_data_message: "No hay datos disponibles",
  ds_pending_reload_hint: 'Haga clic en "Cargar datos" para actualizar el gráfico.',
  ds_pending_reload_message:
    "El gráfico está oculto porque su selección cambió y los datos aún no se han recargado.",
  due_date: "Fecha de vencimiento",
  edit: "Editar",
  edit_customer: "Editar cliente",
  edit_inspection: "Editar inspección",
  edit_safety_assessment: "Editar evaluación de seguridad",
  edit_sensor: "Editar sensor",
  edit_task: "Editar tarea",
  edit_user: "Editar usuario",
  edit_vta: "Editar evaluación VTA",
  efc_info: {
    bullets: {
      a: "AWC = FC − PWP",
      b: "Representa el agua disponible para las plantas.",
      c: "Importante para la planificación del riego",
    },
    formula_intro:
      "Se calcula como la diferencia entre la capacidad de campo y el punto de marchitez permanente:",
    heading: "Capacidad de agua disponible (AWC)",
    intro:
      "La capacidad de agua disponible es la cantidad de agua realmente disponible para las plantas.",
    note: "Valores más altos = el suelo puede almacenar más agua y suministrar a las plantas por más tiempo",
  },
  effective_field_capacity: "Capacidad de campo efectiva",
  either_fill_all_address_or_make_all_empty: "Complete todas las direcciones o deje todo vacío",
  email: "Correo electrónico",
  email_field_is_required: "El campo de correo electrónico es obligatorio",
  email_notification: "Notificaciones por correo electrónico",
  email_schedule: "Horario de correo electrónico",
  end: "Fecha de finalización",
  enter_email_address: "Introduzca la dirección de correo electrónico",
  enter_the_email_address_associated_with_your_account_and_we_will_send_you_a_link_to_reset_your_password:
    "Ingrese la dirección de correo electrónico asociada con su cuenta y le enviaremos un enlace para restablecer su contraseña.",
  error: {
    a_valid_threshold_is_required: "Se requiere un umbral válido",
    choose_location: "Elige Ubicación",
    form: "Los valores se ingresaron incorrectamente. Por favor corrígelos y vuelve a intentarlo.",
    hardware_serial_no_is_required: "Se requiere el número de serie del hardware",
    name_field_is_required: "El campo de nombre es obligatorio",
    please_choose_genus: "Por favor elige género",
    please_choose_species: "Por favor elige especie",
    something_went_wrong: "algo salió mal",
    this_field_is_required: "Este campo es obligatorio",
  },
  error_loading_customers: "Error al cargar clientes",
  error_loading_trees: "Error al cargar árboles",
  error_loading_users: "Error al cargar usuarios",
  evaluation: "Evaluación",
  existing_area: "Área existente",
  expiration_date: "Fecha de expiración",
  explanation: "Explicación",
  export: "Exportar",
  export_data: "Exportar datos",
  export_tasks: "Exportar tareas",
  export_irrigation_description:
    "Exportar tareas de riego a Excel. Muestra todas las entradas de la temporada de vegetación actual (abril - octubre).",
  export_tasks_description:
    "Exportar tareas a Excel. Muestra tareas completadas y planificadas agrupadas por árbol.",
  no_data_to_export: "No hay datos para exportar",
  no_tasks_found: "No se encontraron tareas para los filtros seleccionados.",
  export_sensor_description:
    "Exporte las mediciones de los sensores disponibles para el período de tiempo seleccionado.",
  favorites: "Favoritos",
  fc_info: {
    after_rain: "Después del riego o la lluvia:",
    bullets: {
      a: "El exceso de agua se filtra",
      b: "El suelo se asienta a capacidad de campo.",
      c: "Lo mejor es comenzar a monitorear el riego antes de que se alcance el PWP",
    },
    heading: "Capacidad de campo (FC)",
    intro: "La capacidad de campo es el agua máxima que el suelo puede retener contra la gravedad.",
    note: "Valores típicos: 35–50% (depende del tipo de suelo)",
  },
  feedback: "Comentario",
  feedback_category: "Categoría",
  feedback_category_bug: "Informe de error",
  feedback_category_feature_request: "Solicitud de función",
  feedback_category_positive: "Comentarios positivos",
  feedback_description: "Descripción",
  feedback_priority: "Prioridad",
  feedback_priority_critical: "Crítico",
  feedback_priority_high: "Alto",
  feedback_priority_low: "Bajo",
  feedback_priority_medium: "Medio",
  feedback_problem_url: "URL del problema",
  feedback_screenshot: "Captura de pantalla",
  feedback_submit_success: "Comentarios guardados correctamente.",
  field_capacity: "Capacidad de campo",
  file_download_success: "¡El archivo se ha descargado correctamente!",
  export_failed: "Error en la exportación. Por favor, inténtelo de nuevo.",
  file_upload_successfully: "Carga del archivo exitosamente",
  files_selected: "Archivos seleccionados",
  filter: "Filtrar",
  filter_by_location: "Filtrar por ubicación",
  filter_by_project: "Filtrar por Proyecto",
  filter_tasks: "Filtrar",
  filters: "Filtros",
  findings: "Recomendaciones",
  first_name: "Nombre de pila",
  focus_search: "Búsqueda de enfoque",
  foliage_density: {
    full: "Lleno",
    moderate: "Moderado",
    sparse: "Escaso",
    very_sparse: "muy escaso",
  },
  foliagedensity: "Densidad del follaje",
  forgotpassword: "¿Has olvidado tu contraseña?",
  formula_type: "Fórmula",
  from: "De",
  fungal_infection: "Micosis",
  future_tasks: "Futuro",
  gallery: "Galería",
  general: "General",
  genus: "Género",
  german_name: "ge. Nombre",
  go_to_customers: "Ir a Clientes",
  go_to_users: "Ir a Usuarios",
  greeting: "Hola",
  group_biometrics: "Biometría de árboles",
  group_inventory: "Inventario de árboles",
  group_sensors: "Estado del sensor",
  growth_rate: {
    normal: "Normal",
    slow: "Lento",
    stagnant: "Estancado",
    vigorous: "Vigoroso",
  },
  growth_rate_label: "Índice de crecimiento",
  hardware_serial: "DevEUI",
  hardware_serial_imei: "DevEUI/IMEI",
  hardware_serial_imei_description:
    "La identificación única del sensor. Se puede encontrar en la etiqueta del módulo transmisor. Para sensores LoRaWAN es el DevEUI y para sensores NB-IoT es el IMEI.",
  hardware_serial_no: "Serie de hardware",
  head_purning: "Poda de cabeza",
  health_of_tree_is_drying_out: "La salud del árbol se está secando",
  health_of_tree_is_good: "El estado de salud del árbol es bueno.",
  health_of_tree_is_poor: "La salud del árbol es mala.",
  health_overview: "Resumen de salud",
  health_priority: "Prioridad",
  health_state: "Estado de salud",
  health_state_info: {
    heading: "Sistema de semáforo: comprenda la necesidad de riego",
    intro: "El sistema de semáforos muestra de un vistazo si un árbol necesita riego:",
    note: "Importante: La señal se basa en mediciones y umbrales configurados para este árbol, tipo de suelo y ubicación.",
    states: {
      blue_help: "Riego excesivo; riesgo de anegamiento.",
      blue_label: "🔵 Azul – Demasiado húmedo:",
      gray_help: "Sensor no disponible o sin datos.",
      gray_label: "⚪ Gris – Desconocido:",
      green_help: "El árbol tiene suficiente agua.",
      green_label: "🟢 Verde – No necesita riego:",
      red_help: "¡Regar inmediatamente!",
      red_label: "🔴 Rojo – Se necesita riego con urgencia:",
      yellow_help: "Regar si es operativamente posible.",
      yellow_label: "🟡 Amarillo – Riego recomendado:",
    },
  },
  health_states: {
    critical: "Crítico",
    critical_todo:
      "Lo más probable es que el Árbol sufra estrés por sequía. Riégalo lo antes posible.",
    determines_tree_status: "Este sensor determina el estado del árbol.",
    disconnect: "Desconectar",
    dry: "Seco",
    dry_todo: "Es necesario regar o revisar el árbol lo antes posible.",
    drying_out: "secarse",
    drying_out_todo: "El árbol debe ser regado.",
    frost: "Helada",
    frost_todo: "El árbol podría sufrir daños por heladas.",
    healthy: "Saludable",
    healthy_todo:
      "El Árbol tiene un buen suministro de agua. No es necesario que realice ninguna acción.",
    info_only: "Sólo a título informativo, no determina el estado del árbol.",
    maintenance_needed: "Lecturas de sensores inverosímiles",
    maintenance_needed_todo:
      "Las lecturas del sensor parecen inverosímiles. Verifique y mantenga el sensor.",
    medium: "Medio",
    mixed_sensors: "Los sensores muestran diferentes estados.",
    no_data: "Sin datos",
    no_data_todo: "El sensor está instalado pero no envía datos. Verifique la conexión del sensor.",
    no_sensor: "Sin sensores",
    no_sensor_todo:
      "Ningún sensor instalado. Instalar un sensor para monitorear el estrés hídrico.",
    priority_1_crown: "Sensores de corona (si están presentes, solo estos cuentan)",
    priority_2_soil: "Sensores de suelo (solo si no hay sensores de corona)",
    priority_3_dendrometer: "Dendrómetro (solo si no hay otros sensores)",
    priority_explanation: "El estado de salud se basa en un sistema de prioridades:",
    priority_note:
      "💡 En la vista detallada puedes ver todos los sensores. Sin embargo, el estado del árbol sólo está determinado por la prioridad más alta disponible.",
    priority_title: "¿Cómo se calcula el estado?",
    soil_needs_attention:
      "Los sensores de suelo muestran valores críticos aunque la copa esté sana",
    status_from_crown:
      "Status based on crown sensor: {{crownStatus}}\n(Soil sensor: {{soilStatus}} - for information only)",
    status_from_soil: "Estado basado en el sensor de suelo (no hay sensores de corona presentes)",
    too_wet: "demasiado mojado",
    too_wet_todo: "El árbol o la tierra parecen estar demasiado húmedos y no se deben regar.",
    unknown: "Desconocido",
    unknown_todo: "Se debe revisar el sensor.",
    wet: "demasiado mojado",
    wet_todo: "El árbol o el suelo están demasiado húmedos. No riegues el árbol.",
  },
  health_states_title: "Estado de salud",
  healthy: "Saludable",
  heatmaps: "Mapas de calor",
  height: "Altura",
  help: "Ayuda",
  history: "Historia",
  house_number: "Número de casa",
  hypotheses: "Hipótesis para probar",
  hypotheses_placeholder: "¿Qué hipótesis deberían probarse?",
  image: "Imagen",
  imei: "IMEI",
  impact: "Impacto",
  import_export: "Importar/Exportar",
  import_trees: "Importar árboles",
  improvements: "Mejoras",
  inactive: "Inactivo",
  include_advanced_calibration_values: "Incluir valores avanzados de calibración/depuración",
  include_calculated_values: "incluir valores calculados",
  include_mean_values: "Incluir valores medios",
  include_mean_values_hint:
    "Agrega valores promedio para el período de tiempo seleccionado a la exportación.",
  include_new_moisture_content_data: "Incluir nuevo contenido de humedad (mapeo de especies)",
  include_old_moisture_content_data: "Incluir el contenido de humedad antiguo (schwarzpappel)",
  include_species_mapping_data: "Además, incluya datos de calibración de mapeo de especies.",
  index: "Índice",
  info: "Información",
  inspection_date: "Fecha de inspección",
  inspection_result: {
    failed: "Fallido",
    passed: "Aprobado",
    passed_with_notes: "Aprobado con notas",
  },
  inspection_result_label: "Resultado de la inspección",
  inspection_type: {
    detailed: "Inspección detallada",
    emergency: "Inspección de emergencia",
    post_storm: "Inspección posterior a la tormenta",
    routine: "Inspección de rutina",
    safety: "Inspección de seguridad",
  },
  inspection_type_label: "Tipo de inspección",
  inspections: "Inspecciones",
  inspector: "Inspector",
  install: "Instalar",
  install_sensor: "Instalar sensor",
  installation: "Instalación",
  installation_save_failed: "No se pudo guardar la instalación. Por favor inténtalo de nuevo.",
  installed_at: "Fecha de instalación",
  installed_sensors: "Sensores instalados",
  interactive_map: "Mapa interactivo",
  interval_settings: "Intervalo",
  invalid_date: "Fecha no válida",
  invalid_date_range: "La fecha de inicio debe ser anterior a la fecha de finalización.",
  invalid_email_address: "Dirección de correo electrónico no válida",
  irrigation: "Riego",
  irrigationArea: "Área de riego",
  irrigation_area_assignees_hint:
    "Defina a quién se le debe asignar de forma predeterminada las tareas de riego creadas o preparadas automáticamente por área.",
  irrigation_area_assignees_title: "Responsable por área",
  irrigation_auto_create_task: "Crear tarea automáticamente (omitir sugerencia)",
  irrigation_cycle_count_label: "Número de ciclos de riego",
  irrigation_default_volumes: "Volúmenes de riego predeterminados",
  irrigation_interval_biweekly: "Cada 2 semanas",
  irrigation_interval_custom: "Personalizado (X días)",
  irrigation_interval_daily: "A diario",
  irrigation_interval_title: "Intervalo de riego",
  irrigation_interval_weekly: "Semanalmente",
  irrigation_no_areas: "No hay áreas disponibles.",
  irrigation_phase_default: "Sin fase (predeterminado)",
  irrigation_repeat_every: "Repetir cada",
  irrigation_settings: "Riego",
  irrigation_settings_saved: "Configuración de riego guardada.",
  irrigation_stop_condition_title: "Condición de parada",
  irrigation_stop_fixed_cycles: "Número fijo de ciclos.",
  irrigation_stop_until_green: "Continúe hasta que el estado de salud vuelva a ser verde",
  irrigation_suggestion_assignment_mode_area_default: "Responsable predeterminado por área",
  irrigation_suggestion_assignment_mode_hint:
    "Elija si las sugerencias de riego deben utilizar la persona responsable predeterminada por área o requerir una selección manual en cada aceptación.",
  irrigation_suggestion_assignment_mode_manual:
    "Elija manualmente la persona responsable en cada aceptación.",
  irrigation_suggestion_assignment_mode_title: "Tarea para sugerencias",
  irrigation_trigger_after_days: "Activar después de X días",
  irrigation_trigger_conditions: "Condiciones de activación",
  irrigation_trigger_red: "Activar cuando el estado de salud es rojo",
  irrigation_trigger_yellow: "Activar cuando el estado de salud es amarillo",
  irrigation_validation_custom_days: "Introduzca un intervalo personalizado válido en días.",
  irrigation_validation_fixed_cycles: "Ingrese un recuento de ciclo fijo válido.",
  keyboard_shortcuts: "Atajos de teclado",
  kpi_avg_age: "Edad promedio",
  kpi_avg_crown_diameter: "Diámetro medio de la corona",
  kpi_avg_height: "Altura media",
  kpi_avg_trunk_diameter: "Diámetro medio del tronco",
  kpi_critical_sensors: "Sensores críticos",
  kpi_disconnected_sensors: "Sensores desconectados (últimas 3 horas)",
  kpi_sensor_types: "Tipos de sensores",
  kpi_total_sensors: "Número de sensores",
  kpi_total_species: "Número de especies de árboles",
  kpi_total_trees: "Número de árboles",
  language: "Idioma",
  language_description: "Selecciona tu idioma preferido",
  last_10_measurements: "Últimas 10 mediciones",
  last_battery: "Última batería",
  last_date: "Última fecha",
  last_measurements: "Últimas mediciones",
  last_name: "Apellido",
  last_value: "Último valor",
  latin_name: "lat. Nombre",
  latitude: "Latitud",
  leaf_photos: "Fotos de Hoja",
  leave_empty_to_keep_current: "Déjelo vacío para mantener la contraseña actual",
  less_than_60_of_the_battery_remaining: "Queda menos del 60% de la batería",
  ligature_control: "Control de ligadura",
  limitations: "Limitaciones de los resultados/importancia",
  limitations_placeholder:
    "¿Qué tan significativos son los resultados? ¿Cuáles son las limitaciones?",
  limits_alerts: "Límites y alertas",
  live_monitoring: "Monitoreo en vivo",
  load_data: "Cargar datos",
  loading: "Cargando ...",
  loading_data: "Cargando datos...",
  loading_trees: "Cargando árboles…",
  location: "Ubicación",
  login: "Acceso",
  login_credentials: "Credencial de inicio de sesión",
  logout: "Finalizar la sesión",
  longitude: "Longitud",
  looks_like_you_dont_have_selected_area_please_select_the_area_to_get_data:
    "Parece que no has seleccionado el área. Seleccione un área para obtener datos.",
  looks_like_you_dont_have_selected_sensor_please_select_a_sensor_to_get_data:
    "Parece que no has seleccionado el sensor. Seleccione un sensor para obtener datos.",
  looks_like_you_dont_have_selected_tree_please_select_a_tree_to_get_data:
    "Parece que no has seleccionado el árbol. Seleccione un árbol para obtener datos.",
  lora_wan: "LoRaWAN",
  maintainance: "mantenimiento",
  maintenance: "Mantenimiento",
  maintenance_needed: "Lecturas de sensores inverosímiles",
  manage_customers_description: "Gestionar la información y el acceso de los clientes.",
  manage_parent_child_relationships: "Gestionar las relaciones entre padres e hijos",
  manage_trees_without_sensors: "Gestionar árboles sin sensores",
  manage_users_description: "Administrar cuentas de usuario y permisos",
  map_add_tree_hint: "Mueva el mapa para establecer la ubicación del árbol.",
  map_add_tree_mode: "Modo de posicionamiento activo",
  map_sidebar_info: {
    description:
      "Esta barra lateral enumera todas las áreas de riego y sus árboles en una vista jerárquica.",
    features: {
      add_tree_help: "Utilice el ícono más para agregar nuevos árboles a un área.",
      add_tree_label: "Añade un árbol:",
      expand_areas_help: "Haga clic en un área para mostrar todos los árboles asociados.",
      expand_areas_label: "Ampliar áreas:",
      parent_child_help:
        "Los árboles con sensores pueden actuar como árboles padres y representar árboles adicionales.",
      parent_child_label: "Relaciones entre padres e hijos:",
      select_tree_help: "Haga clic en un árbol para mostrarlo en el mapa y abrir sus detalles.",
      select_tree_label: "Seleccione un árbol:",
    },
    features_heading: "Características:",
    heading: "Navegación en la vista de mapa",
    note: "La codificación de colores de los árboles refleja el estado de salud (verde = saludable, amarillo = seco, rojo = seco, gris = desconocido).",
    title: "Vista de mapa: áreas y árboles",
  },
  map_view: "Vista de mapa",
  mark_all_as_seen: "Marcar todo como visto.",
  mark_as_Seen: "Marcar como se ve",
  master_data: "Gestión de datos maestros",
  materials: "Archivos/Fotos/Materiales del Proyecto",
  materials_placeholder: "Enlaces a archivos, fotografías u otros materiales.",
  maximum_of: "Máximo",
  mean: "Significar",
  meaning_measurement: "Significado de la medida",
  measure_type_free_entry: "Entrada gratuita",
  measure_type_inspection: "Inspección",
  measure_type_irrigation: "Riego",
  measure_type_pruning: "Poda",
  measure_type_sensor_maintenance: "Mantenimiento de sensores",
  measure_type_soil_maintenance: "Mantenimiento del suelo",
  menu: "Menú",
  methodology: "¿Cómo responder la pregunta? (Metodología, Selección de Árboles, Instalación)",
  methodology_placeholder:
    "Describir metodología, ubicaciones, selección de árboles, instalación de sensores...",
  mobile_column: "Columna",
  mobile_table_column_preferences: "columnas móviles",
  mobile_table_column_preferences_hint:
    "Elija qué 2 columnas se muestran en dispositivos móviles (teléfonos inteligentes).",
  moisture_content: "Índice de humedad Treesense",
  moisture_content_cap_description:
    "Valores límite a 0-1 / 0-100%. Desactívelo para mostrar valores analíticos sin procesar.",
  moisture_content_cap_setting: "Valores de contenido de humedad de la tapa",
  moisture_content_display_description:
    "Elija cómo TreeSense muestra los valores de contenido de humedad.",
  moisture_content_display_fraction: "Fracción (0-1)",
  moisture_content_display_fraction_description: "Muestra valores como 0,34.",
  moisture_content_display_percent: "Porcentaje (0-100)",
  moisture_content_display_percent_description: "Mostrar valores como 34%.",
  moisture_content_display_setting: "Visualización del contenido de humedad",
  moisture_formula_hint:
    "La nueva fórmula compensa mejor los efectos de la temperatura y proporciona valores más estables.",
  moisture_formula_improvements:
    "Hemos mejorado y automatizado significativamente la configuración de calibración de temperatura. Hasta ahora sólo se compensaba el álamo negro. Ahora intentamos compensar el mayor número posible de especies de árboles. Si esto no es posible, utilizamos las especies de árboles filogenéticamente más cercanas.",
  moisture_formula_learn_more: "Más información",
  moisture_formula_new_description:
    "Generalmente más estable ya que compensa mejor los efectos de la temperatura. Sin embargo, esto puede hacer que los eventos de riego o lluvia sean menos notorios.",
  moisture_formula_note:
    "Nota: La elección de la fórmula afecta la visualización de los valores de humedad en todos los gráficos.",
  moisture_formula_old_description:
    "Más afectado por las fluctuaciones de temperatura, pero puede mostrar los eventos de riego y lluvia con mayor claridad.",
  moisture_formula_setting: "Fórmula de contenido de humedad",
  moisture_formula_threshold_warning:
    "Al utilizar la nueva fórmula, los umbrales también cambian. Es necesario revisarlos y ajustarlos después del cambio para que las advertencias y evaluaciones sigan siendo correctas.",
  moisture_formula_wiki_link:
    "https://www.treesense.net/wiki_post/treesense-pulse-was-ist-der-treesense-feuchtigkeitsindex/",
  month_april: "Abril",
  month_august: "Agosto",
  month_december: "Diciembre",
  month_february: "Febrero",
  month_january: "Enero",
  month_july: "Julio",
  month_june: "Junio",
  month_march: "Marzo",
  month_may: "Puede",
  month_november: "Noviembre",
  month_october: "Octubre",
  month_september: "Septiembre",
  more_actions: "Más acciones",
  more_information: "Más información",
  more_tasks: "más",
  move_down: "Bajar",
  move_up: "Subir",
  name: "Nombre",
  navigation: "Navegación",
  nb_iot: "NB-IoT",
  network_type: "Tipo de red",
  new_area: "Nueva Área",
  new_formula: "Nueva fórmula",
  new_project: "Nuevo proyecto",
  new_task: "Nueva tarea",
  newproject: "Nuevo proyecto",
  next_inspection: "Próxima inspección",
  next_inspection_date: "próxima fecha de inspección",
  next_irrigation: "Próximo riego",
  no_data: "No hay datos disponibles",
  no_data_available_please_check_data_available_to_this_date:
    "No hay datos disponibles, por favor consulte los datos disponibles hasta la fecha",
  no_data_for_selected_range:
    "No hay datos disponibles para el rango de tiempo y los parámetros seleccionados.",
  no_data_found: "No se encontraron datos",
  no_health_data: "No hay datos de salud disponibles",
  no_inspections: "No se registraron inspecciones",
  no_installation: "Sin instalación",
  no_photos: "No se subieron fotos",
  no_project_selected: "Ningún proyecto seleccionado",
  no_projects_available: "No hay proyectos disponibles",
  no_results: "Sin resultados",
  no_results_action: "Restablecer filtros",
  no_safety_assessments: "No se han registrado evaluaciones de seguridad",
  no_sensor_is_selected: "No se ha seleccionado ningún sensor",
  no_sensor_mode: "Modo sin sensor",
  no_sensors_found: "No se encontraron sensores",
  no_tasks: "No hay tareas disponibles",
  no_tasks_subtitle: "Crea tu primera tarea",
  no_tree_is_selected: "No se ha seleccionado ningún árbol",
  no_trees_available: "No hay árboles disponibles",
  no_trees_found: "No se encontraron árboles",
  no_vta_assessments: "No se registraron evaluaciones de VTA",
  not_found: "Extraviado",
  not_provided: "No proporcionado",
  not_sending: "No enviando",
  note: "Nota",
  notes: "Notas",
  notifications: "Notificaciones",
  number_of_tree_based_on_health_status: "Número de árboles según el estado de salud.",
  number_of_tree_on_respective_area: "Número de árboles en el área respectiva",
  of: "de",
  okay: "Bueno",
  old_formula: "Antigua fórmula",
  one_day: "1 día",
  one_day_info: "Mostrar datos de las últimas 24 horas.",
  one_week: "1 semana",
  one_week_info: "Mostrar datos de los últimos 7 días",
  one_year: "1 año",
  one_year_info: "Mostrar datos de los últimos 12 meses.",
  open: "Abierto",
  open_questions: "Preguntas abiertas / Próximos pasos",
  open_questions_placeholder: "¿Qué preguntas quedan abiertas? ¿Cuáles son los próximos pasos?",
  open_sidebar: "Abrir barra lateral",
  open_time_controls: "Controles de tiempo abiertos",
  optional_soil_name: "Nombre de suelo opcional",
  other: "Otro",
  overall: "En general",
  overdue: "Atrasado",
  overview: "Descripción general",
  pagination_out_of: "fuera de",
  parentTree: "Árbol padre",
  parent_child_mode: "Modo padre-hijo",
  password: "Contraseña",
  password_do_not_match: "La contraseña no coincide",
  password_field_is_required: "El campo de contraseña es obligatorio",
  password_reset_request_sent_generic:
    "Si existe una cuenta para este correo electrónico, le enviaremos un enlace de restablecimiento.",
  past_tasks: "Pasado",
  permanent_wilting_point: "Punto de marchitez permanente",
  persona: "Persona",
  persona_labels: {
    city_tree_manager: "Administrador del árbol de la ciudad",
    irrigation_team: "Equipo de riego",
    research_partner: "Socio de investigación",
    tree_inspector: "Inspector de árboles",
    treesense_support: "Soporte de TreeSense",
  },
  personal_data: "Datos personales",
  pest_infestation: "Infestación de plagas",
  phase: "Fase",
  phone_number: "Número de teléfono",
  photos: "Fotos",
  planting_time: "Tiempo de siembra",
  planting_year: "Año de siembra",
  please_drag_the_variable_to_display_data: "Arrastre la variable para mostrar los datos.",
  please_select_project: "Por favor seleccione un proyecto para ver los datos",
  please_select_project_to_view_map: "Por favor seleccione un proyecto para ver el mapa",
  please_select_sensor: "Por favor seleccione un sensor.",
  position: "Posición",
  position_confirmed: "Posición confirmada",
  print_tree_tag: "Imprimir etiqueta de árbol",
  priority: {
    high: "Alto",
    low: "Bajo",
    medium: "Medio",
    urgent: "Urgente",
  },
  priority_high: "Alto",
  priority_low: "Bajo",
  priority_medium: "Medio",
  problem_in_creating_customer: "Problema al crear cliente.",
  problem_in_creating_sensor: "Problema al crear sensor",
  profile: "Perfil",
  proj: "Proyecto",
  project: {
    aim: "Tipo de proyecto",
    aim_general_drought_stress_monitoring: "Monitoreo general del estrés por sequía",
    aim_groundwater_lowering_monitoring: "Monitoreo de reducción de agua subterránea",
    aim_irrigation_demand_determination: "Determinación de la demanda de riego",
    aim_irrigation_optimization: "Optimización del riego",
    aim_irrigation_optimization_young_trees: "Optimización del riego: árboles jóvenes",
    aim_mistletoe_control: "Control del muérdago",
    aim_old_tree_monitoring: "Monitoreo de árboles viejos",
    aim_partnership_project: "Proyecto de asociación",
    aim_smart_city: "Ciudad inteligente",
    aim_technology_validation: "Validación de tecnología",
    challenges: "Problemas durante el proyecto",
    challenges_placeholder: "¿Qué problemas ocurrieron? ¿Qué necesitaba el cliente?",
    description: "Descripción del proyecto",
    description_placeholder: "Describe brevemente el proyecto.",
    hypotheses: "Hipótesis para probar",
    hypotheses_placeholder: "¿Qué hipótesis deberían probarse?",
    limitations: "Limitaciones de los resultados/importancia",
    limitations_placeholder:
      "¿Qué tan significativos son los resultados? ¿Cuáles son las limitaciones?",
    materials: "Archivos/Fotos/Materiales del Proyecto",
    materials_placeholder: "Enlaces a archivos, fotografías u otros materiales.",
    methodology: "Metodología",
    methodology_placeholder:
      "Describir metodología, ubicaciones, selección de árboles e instalación de sensores...",
    name: "Nombre del proyecto",
    open_questions: "Preguntas abiertas / Próximos pasos",
    open_questions_placeholder: "¿Qué preguntas quedan abiertas? ¿Cuáles son los próximos pasos?",
    research_question: "Pregunta de investigación",
    research_question_placeholder: "¿Cuál es la pregunta central de investigación?",
    results: "Resultados",
    results_placeholder: "¿Cuáles son los principales resultados del proyecto?",
    select_aim: "Seleccione el tipo de proyecto",
  },
  project_details: {
    empty_project: "Proyecto vacío, comience a agregar árboles.",
    empty_sensors: "No se han creado sensores. Comience agregando sensores.",
    empty_trees: "Árboles vacíos, comience a agregar árboles.",
    no_area_selected: "Por favor seleccione área para ver detalles",
    no_sensor_selected: "Seleccione un sensor para mostrar los detalles.",
    no_tree_selected: "Seleccione el árbol para ver los detalles",
  },
  project_name: "Proyecto",
  project_not_found: "Proyecto no encontrado",
  projects: "Proyectos",
  projects_views: "Proyectos",
  pulse_resistance_in_kOhm: "Resistencia al pulso en kOhm",
  pulse_sensor: "Sensor de pulso",
  push_message_notification: "Notificaciones de mensajes push",
  pwp_info: {
    bullets: {
      a: "Las plantas ya no pueden absorber suficiente agua",
      b: "Pueden producirse daños irreversibles",
      c: "El riego inmediato es fundamental",
    },
    heading: "Punto de marchitez permanente (PWP)",
    intro:
      "El punto de marchitez permanente es el contenido de agua del suelo en el que las plantas ya no pueden absorber agua.",
    note: "Valores típicos: 10–15% (depende del tipo de suelo)",
    when_reached: "Cuando la humedad del suelo alcanza o cae por debajo de este valor:",
  },
  qr_scanner: "Escáner QR",
  rain: "Lluvia",
  rainfall: "Lluvia",
  rainfall_mm: "Precipitación (mm)",
  reason: "Razón",
  recommendations: "Recomendaciones",
  records: "Archivos",
  reference: "Referencia",
  refresh_health: "Actualizar datos de salud",
  refresh_health_error: "No se pudieron actualizar los datos de salud",
  remove: "Eliminar",
  remove_3d_model: "Eliminar modelo 3D",
  removed_at: "Fecha de remoción",
  replace_3d_model: "Reemplazar modelo 3D",
  report_after: "Después",
  report_avg_control_interval: "Intervalo de control promedio",
  report_avg_moisture_index: "Índice de humedad promedio",
  report_avg_moisture_over_time: "Índice de humedad promedio a lo largo del tiempo",
  report_avg_violation_to_completion: "Promedio violación a la finalización de la tarea",
  report_batteries_low: "Baterías < 20%",
  report_before: "Antes",
  report_before_after_analysis: "Análisis antes/después",
  report_completed_tasks: "Tareas completadas",
  report_controls_per_month: "Controles por mes",
  report_controls_performed: "Controles realizados",
  report_critical_trees: "Árboles críticos",
  report_critical_vs_completed: "Árboles críticos vs medidas completadas",
  report_critical_with_open_task: "Árboles críticos con tarea abierta.",
  report_date: "Fecha",
  report_documented_maintenance: "Acciones de mantenimiento documentadas.",
  report_effect_tab: "Informe de efectos",
  report_health_distribution: "Distribución del estado de salud",
  report_index_change_after_irrigation: "Cambio de índice después del riego.",
  report_index_change_after_pruning: "Cambio de índice después de la poda.",
  report_irrigation_vs_index: "Riegos vs índice medio",
  report_kataster_tab: "Informe catastrófico",
  report_maintenance_type_distribution: "Distribución del tipo de mantenimiento",
  report_offline_sensors: "Sensores fuera de línea",
  report_overdue_tasks: "Tareas atrasadas",
  report_rain_vs_index: "Índice de lluvia vs promedio",
  report_range_1m: "1 mes",
  report_range_1w: "1 semana",
  report_range_1y: "1 año",
  report_range_3m: "3 meses",
  report_sensor_tab: "Informe de sensores",
  report_task_status_distribution: "Distribución del estado de la tarea",
  report_threshold_violations: "Violaciones de umbrales",
  report_total_active_sensors: "Sensores activos totales",
  report_total_trees: "Árboles totales",
  report_violations: "Violaciones",
  reporting: "Informes",
  reports_analysis: "Informes y análisis",
  represent_tree: "Representar árbol",
  represented_tree: "Árbol representado",
  required: "Requerido",
  required_information: "* Información requerida",
  research_question: "Pregunta de investigación/objetivos del proyecto",
  research_question_placeholder: "¿Cuál es la pregunta u objetivo principal de este proyecto?",
  reset: "Reiniciar",
  reset_chart: "Restablecer gráfico",
  reset_filters: "Restablecer todo",
  reset_info: "Restablecer todas las configuraciones del gráfico a sus valores predeterminados",
  reset_password: "Restablecer contraseña",
  reset_table_column_preferences: "Restaurar valores predeterminados",
  reset_zoom: "Restablecer zoom",
  resis_temp_comp: "ResistenciaTempComp",
  resistance: "Resistencia",
  resource_planning: "Planificación de recursos",
  restore_view: "Restaurar vista",
  data_science_chart_tools: "Gráficos",
  results: "Resultados",
  results_placeholder: "¿Cuáles son los principales resultados del proyecto?",
  risk_assessment: "Evaluación de riesgos",
  risk_level: {
    critical: "Riesgo crítico",
    high: "Alto riesgo",
    low: "Bajo riesgo",
    medium: "Riesgo medio",
  },
  risklevel: "Nivel de riesgo",
  role: "Role",
  root_ball: "cepellón",
  root_defects: "Defectos de raíz",
  root_system: {
    DE: "Profundamente arraigado",
    HE: "Arraigado en el corazón",
    SH: "de raíces poco profundas",
    UN: "Desconocido",
  },
  safety_status: {
    action_required: "Acción requerida",
    monitoring_required: "Monitoreo requerido",
    safe: "Seguro",
    unsafe: "Inseguro",
  },
  save: "Ahorrar",
  save_changes: "Guardar cambios",
  save_settings: "Guardar configuración",
  saved: "Guardado",
  saving: "Ahorro",
  scan_to_add_sensor: "Escanear para agregar sensor",
  search: "Buscar",
  search_address: "Buscar dirección",
  search_area: "Área de búsqueda",
  search_sensor: "Sensor de búsqueda",
  search_sensors: "Buscar sensores...",
  search_tasks: "Buscar tareas...",
  search_tree: "Árbol de búsqueda",
  search_trees: "Buscar árboles...",
  select_aim: "Seleccionar objetivo del proyecto",
  select_all: "Seleccionar todo",
  select_camera: "Seleccionar cámara",
  select_child_trees: "Seleccionar árboles secundarios",
  select_customer_type: "Seleccione tipo de cliente",
  select_depth: "Seleccionar profundidad",
  select_language: "Seleccionar idioma",
  select_phase: "Seleccionar Fase",
  select_project: "Seleccionar Proyecto",
  select_sensor: "Seleccionar sensor",
  select_sensor_search: "Buscar sensor...",
  select_task_types: "Seleccionar tipos de tareas",
  select_year: "Elige Año",
  send_feedback: "Enviar comentarios",
  sending: "Envío...",
  sensor: "Sensor",
  sensor_already_installed: "Este sensor ya está instalado activamente.",
  sensor_configuration: "Configuración de sensores",
  sensor_data: "Datos de sensores",
  sensor_details: {
    empty_sensors: "Sensor vacío, comience a agregar árboles.",
    no_data_found: "No se encontraron datos del sensor",
    no_recent_measurements: "Ninguna medición en los últimos 3 meses.",
    no_recent_measurements_hint:
      "Para inspeccionar datos más antiguos, utilice la vista de análisis de datos y ajuste el rango de tiempo.",
    no_sensor_selected: "Seleccione el sensor para ver los detalles",
    no_evaluation_possible: "No es posible la evaluación.",
  },
  sensor_disconnect: "Desconexión del sensor",
  sensor_form: {
    hardware_serial: "Serie de hardware",
    name: "Nombre",
    network_type: "Tipo de red",
    sensor_type: "Tipo de sensor",
    threshold: "Límite",
  },
  sensor_name: "Nombre del sensor",
  sensor_state: "Estado del sensor",
  sensor_status: "Estado del sensor",
  sensor_status_change_to_dry: "El estado del sensor cambia a seco",
  sensor_status_change_to_drying_out: "El estado del sensor cambia a secado",
  sensor_status_change_to_no_connection: "El estado del sensor cambia a sin conexión",
  sensor_status_description:
    "El estado del sensor indica si el sensor está funcionando o si requiere mantenimiento.",
  sensor_type: "Tipo de sensor",
  sensor_types: "Tipos de sensores",
  sensors: "Sensores",
  sensors_monitoring: "Sensores y monitoreo",
  sensors_views: "Sensores",
  sesnor_height_hint:
    "Arrastre el icono del sensor o ingrese la altura. Los valores están redondeados.",
  set_default: "Establecer predeterminado",
  settings: "Ajustes",
  settings_saved_successfully: "Configuración guardada exitosamente",
  settings_user_info: {
    persona: {
      city_tree_manager: {
        changes: [
          "Página predeterminada: Panel de control",
          "Enfoque: visión general, catastro y trabajo orientado a la presentación de informes.",
        ],
        description:
          "Perfil de UX para usuarios que necesitan una descripción general orientada a la gestión en el panel, el catastro y el análisis.",
      },
      irrigation_team: {
        changes: [
          "Página predeterminada: Tareas",
          "Enfoque: flujos de trabajo de riego y ejecución operativa",
        ],
        description:
          "Perfil UX para usuarios que trabajan principalmente en flujos de trabajo de ejecución y riego basados ​​en tareas.",
      },
      research_partner: {
        changes: [
          "Página predeterminada: ciencia de datos",
          "Enfoque: exploración, datos de sensores y análisis.",
        ],
        description:
          "Perfil UX para usuarios que trabajan principalmente en ciencia de datos y análisis basado en sensores.",
      },
      tree_inspector: {
        changes: [
          "Página predeterminada: Catastro de árboles",
          "Enfoque: inspecciones, registros de árboles y trabajo de campo.",
        ],
        description:
          "Perfil UX para usuarios que trabajan principalmente en el catastro de árboles y realizan inspecciones en campo.",
      },
      treesense_support: {
        changes: [
          "Página predeterminada: Sensores",
          "Enfoque: estado del sensor y flujos de trabajo de soporte técnico",
        ],
        description:
          "Perfil UX para usuarios que principalmente monitorean sensores y manejan procesos de soporte técnico.",
      },
    },
    persona_footer:
      "Las personas dan forma al punto de entrada predeterminado y al enfoque de UX. El acceso efectivo aún proviene de los permisos de la función de backend.",
    persona_section_title: "Qué cambia esto en la interfaz de usuario",
    role: {
      admin: {
        changes: [
          "Puede gestionar flujos de trabajo organizacionales sin tener la propiedad total de la plataforma",
          "Por lo general, tiene un amplio acceso a nivel de cliente según los permisos del backend.",
        ],
        description:
          "Rol administrativo para la gestión a nivel de cliente y flujos de trabajo organizacionales.",
      },
      basic: {
        changes: [
          "Trabajos dentro de proyectos y áreas asignadas.",
          "Las asignaciones de área son especialmente relevantes para el acceso operativo",
        ],
        description:
          "Rol de usuario final operativo para el trabajo diario en proyectos y áreas asignadas.",
      },
      superuser: {
        changes: [
          "Puede gestionar usuarios, configuraciones y administración a nivel de cliente.",
          "Normalmente tiene el acceso más amplio a todos los módulos.",
        ],
        description:
          "Rol administrativo completo con acceso irrestricto a las áreas de configuración y gestión.",
      },
    },
    role_footer:
      "Los roles determinan los permisos efectivos. Las personas solo influyen en la navegación predeterminada y el enfoque de UX.",
    role_section_title: "Qué cambia esto en el acceso",
  },
  show_all_trees: "Mostrar todos los árboles",
  show_shortcuts: "Mostrar atajos",
  show_tree_list: "Mostrar lista de árbol",
  showing: "Demostración",
  showing_results: "Showing {{count}} results",
  signup: "Inscribirse",
  single_tree_view: "Vista de árbol único",
  six_months: "6 meses",
  six_months_info: "Mostrar datos de los últimos 6 meses.",
  size: "Tamaño",
  skip: "Saltar",
  soil: "Suelo",
  soil_info: {
    heading: "Comprender los parámetros del suelo.",
    intro: "Estos valores describen la capacidad de retención de agua del suelo en este lugar:",
    items: {
      efc_help:
        "Cantidad de agua que las plantas realmente pueden absorber (entre PWP y capacidad de campo).",
      efc_label: "Capacidad de agua disponible (AWC):",
      fc_help: "Máxima cantidad de agua que el suelo puede retener contra la gravedad.",
      fc_label: "Capacidad de campo (FC):",
      pwp_help:
        "Contenido de agua por debajo del cual las plantas ya no pueden extraer suficiente agua y se marchitan.",
      pwp_label: "Punto de marchitez permanente (PWP):",
    },
    note: "Estos parámetros se configuran por ubicación e influyen en las recomendaciones de riego.",
  },
  soil_moisture: "Humedad del suelo",
  soil_moisture_edit: "Umbrales vol. Humedad del suelo",
  soil_moisture_sensor: "Sensor de humedad del suelo",
  soil_moisture_vg: "Humedad del suelo (van Genuchten)",
  soil_name: "Nombre del suelo",
  soil_water_tension: "Tensión hídrica del suelo",
  soil_water_tension_edit: "Umbrales de tensión hídrica del suelo",
  soil_water_tension_sensor: "Sensor de tensión del agua del suelo",
  soil_water_tension_vg: "Tensión hídrica del suelo (van Genuchten)",
  something_wrong: "algo salió mal",
  species: "Especies",
  start_scanning: "Iniciar escaneo",
  start_typing_to_search: "Empieza a escribir para buscar...",
  start_with_adding_new_project: "Comience agregando un nuevo proyecto",
  state: "Estado",
  statistics: "Estadística",
  stats_completed: "Terminado",
  stats_in_progress: "En curso",
  stats_overdue: "Atrasado",
  stats_total: "Tareas totales",
  status: "Estado",
  status_BEAUFTRAGT: "Oficial",
  status_ERLEDIGT: "Terminado",
  status_GEPLANT: "Planificado",
  status_IN_ARBEIT: "En curso",
  status_NICHT_GESCHAFFT: "No completado",
  status_completed: "Terminado",
  status_in_progress: "En curso",
  status_planned: "Planificado",
  status_review: "En revisión",
  stem_cane_removal: "Extracción de caña de tallo",
  stop_scanning: "Dejar de escanear",
  street_name: "Nombre de la calle",
  structural_defects: "Defectos estructurales",
  superuser: "Superusuario",
  table_column_preferences: "Columnas visibles",
  table_column_preferences_hint:
    "Elija qué columnas se muestran en las tablas de árboles, sensores y tareas.",
  table_columns_sensors: "Sensores",
  table_columns_trees: "Árboles",
  table_columns_tasks: "Tareas",
  task: "Tarea",
  task_assignee: "Cesionario",
  task_assignee_select_placeholder: "Seleccionar cesionario",
  task_attachments: "Adjuntos",
  task_comments: "Comentarios",
  task_description: "Descripción",
  task_description_placeholder: "Introduzca la descripción de la tarea",
  task_details: "Detalles de la tarea",
  task_due_date: "Fecha de vencimiento",
  task_filter_due_period: "Plazo de vencimiento",
  task_filter_measure_type: "Tipo de tarea",
  task_filter_overdue: "Atrasado",
  task_filter_pruning_type: "Tipo de poda",
  task_filter_this_month: "este mes",
  task_filter_this_week: "Esta semana",
  task_filter_today: "Hoy",
  task_form: {
    assigned_to: "Asignado a",
    assignment: "Asignación",
    basic_info: "Información básica",
    created_at: "Creado en",
    created_by: "Creado por",
    description: "Descripción",
    description_placeholder: "Introduzca la descripción de la tarea",
    due_date: "Fecha de vencimiento",
    priority: "Prioridad",
    priority_high: "Alto",
    priority_low: "Bajo",
    priority_medium: "Medio",
    select_task_to_view: "Seleccione una tarea para ver los detalles",
    select_user: "Seleccionar usuario",
    status: "Estado",
    status_completed: "Terminado",
    status_in_progress: "En curso",
    status_pending: "Pendiente",
    title: "Título",
    title_placeholder: "Ingrese el título de la tarea",
    tree: "Árbol",
  },
  task_location: "Ubicación",
  task_location_placeholder: "Introduce la ubicación",
  task_priority: "Prioridad",
  task_status: "Estado",
  task_type: "Tipo de tarea",
  task_plan: "Plan de tareas",
  completed_tasks: "Tareas completadas",
  planned_tasks: "Tareas planificadas",
  next_task: "Próxima tarea",
  task_suggestion_bulk_create: "Crear seleccionado",
  task_suggestion_bulk_created_success: "Sugerencias seleccionadas creadas.",
  task_suggestion_bulk_dismiss: "Descartar seleccionado",
  task_suggestion_bulk_dismissed_success: "Se descartaron las sugerencias seleccionadas.",
  task_suggestion_bulk_manual_only:
    "En modo manual las sugerencias de riego sólo se pueden aceptar una a una.",
  task_suggestion_choose_assignee_body:
    "Elija quién debe ser asignado al aceptar esta sugerencia de riego.",
  task_suggestion_choose_assignee_title: "Elige persona responsable",
  task_suggestion_choose_assignee_validation: "Por favor seleccione una persona.",
  task_suggestion_create_task: "Crear tarea",
  task_suggestion_created: "Creado",
  task_suggestion_created_success: "Tarea creada a partir de sugerencia.",
  task_suggestion_dismiss: "Despedir",
  task_suggestion_dismissed_success: "Sugerencia descartada.",
  task_suggestion_health_red: "Rojo",
  task_suggestion_health_yellow: "Amarillo",
  task_suggestion_reason_fallback: "El estado de salud requiere atención.",
  task_suggestions_empty: "No hay sugerencias pendientes.",
  task_suggestions_open_page: "Abrir sugerencias",
  task_suggestions_pending_count: "sugerencias pendientes",
  task_suggestions_title: "Tareas sugeridas",
  task_title: "Título",
  task_title_placeholder: "Ingrese el título de la tarea",
  task_tree_info: "Información del árbol",
  task_tree_location: "Árbol y ubicación",
  task_tree_select: "Árbol",
  task_tree_select_placeholder: "Seleccionar árbol",
  task_tree_species: "Especies de árboles",
  task_tree_species_placeholder: "Introduzca especies de árboles",
  tasks: "Tareas",
  tasks_completed_short: "terminado",
  tasks_workflows: "Tareas y flujos de trabajo",
  temperature: "Temperatura",
  the: "el",
  theme: "Tema",
  theme_dark: "Oscuro",
  theme_dark_desc: "Agradable a la vista",
  theme_description: "Elige cómo te parece TreeSense",
  theme_light: "Luz",
  theme_light_desc: "Brillante y claro",
  theme_system: "Sistema",
  theme_system_desc: "Sigue tu dispositivo",
  three_weeks: "3 semanas",
  three_weeks_info: "Mostrar datos de las últimas 3 semanas.",
  threshold: "Límite",
  thresholds: "Umbrales",
  thresholds_select_one_sensor: "Seleccione exactamente un sensor para mostrar los umbrales.",
  tick_the_checkbox_to_download_data: "Marque la casilla de verificación para descargar datos",
  ticket_system: "Sistema de tickets",
  time: "Tiempo",
  time_range_info:
    "Seleccione un rango de tiempo para ver datos históricos. Elija entre rangos preestablecidos o defina un período personalizado.",
  time_range_selection: "Selección de rango de tiempo",
  timeframe: "Periodo de tiempo",
  timeframe_hint:
    "Déjelo como está para descargar los últimos 30 días. Ajuste el rango para limitar su exportación.",
  to: "A",
  today: "Hoy",
  toggle_mobile_menu: "Alternar menú móvil",
  toggle_project_sidebar: "Alternar barra lateral del proyecto",
  tomorrow: "Mañana",
  top_species: "Las 5 principales especies de árboles",
  top_species_info_body:
    "Muestra las cinco especies de árboles más frecuentes en su selección actual.",
  top_species_info_title: "Especies de árboles más comunes",
  topiary: "Poda artística",
  total_sensors: "Número total de sensores",
  total_trees: "Número total de árboles",
  total_trees_species: "Número total de especies de árboles",
  tour_start: "Iniciar recorrido",
  traffic_safety_assessments: "Evaluaciones de seguridad vial",
  traffic_safety_status: "Estado de seguridad del tráfico",
  tree: "Árbol",
  treeNoSensor: "Árbol sin sensor",
  tree_added_successfully: "Árbol agregado exitosamente",
  tree_and_sensor: "Árbol y sensor",
  tree_cadastre: "Catastro de árboles",
  tree_cadastre_no: "Catastro de árboles No",
  tree_control: "Control de árboles",
  tree_count: "Conteo de árboles",
  tree_form: {
    info: {
      represent: {
        heading: "Árbol representativo",
        help: "Seleccione el árbol que representa esta ubicación para análisis e informes.",
        note: "Para analizar los datos con la mayor precisión posible, recomendamos subir una foto del árbol y una hoja representativa al mismo tiempo.",
      },
      sensors: {
        heading: "Sensores",
        help: "Asigna los sensores que pertenecen a este árbol.",
        note: "Los sensores seleccionados se utilizan para mostrar datos en vivo y calcular recomendaciones de riego.",
      },
      soil: {
        heading: "Parámetros del suelo",
        max_f_help: "Valor máximo del sensor para árboles bien regados (F = regado).",
        max_f_label: "Máx. valor (árboles irrigados)",
        max_nf_help: "Valor máximo del sensor para árboles sin riego (NF = sin riego).",
        max_nf_label: "Máx. valor (árboles secano)",
        note: "Estos umbrales se utilizan para derivar recomendaciones de riego y colores de semáforo.",
        pwp_help:
          "Valor del sensor en el que el árbol alcanza el punto de marchitez permanente (PWP).",
        pwp_label: "Punto de marchitez permanente (PWP)",
      },
    },
    more_info: "Más información",
    position: "Posición",
    representTree: "árboles infantiles",
    sensors: "Sensores",
    soil: "Suelo",
    tree_profile: "Perfil del árbol",
  },
  tree_form_info: {
    add_title: "Agregar árbol",
    edit_title: "Editar árbol",
    more: {
      heading: "Más información",
      metrics_help:
        "Circunferencia del tronco (cm), altura (m), diámetro de la copa (m) — opcional.",
      metrics_label: "Métrica:",
      note: "Útil para informes y recomendaciones; se puede agregar más tarde.",
      phase_help: "Elija Establecimiento, Desarrollo o Mantenimiento.",
      phase_label: "Fase:",
      species_help: "Busque usando “nombre latino | nombre común”.",
      species_label: "Especies de árboles:",
      year_help: "Seleccione el año de siembra.",
      year_label: "Año de siembra:",
    },
    position: {
      altitude_help: "Opcional. Déjelo vacío si lo desconoce.",
      altitude_label: "Altitud:",
      heading: "Posición",
      latlng_help: "Requerido. Ingrese coordenadas o coloque el marcador en el mapa.",
      latlng_label: "Latitud / Longitud*:",
      map_help:
        "Utilice las herramientas del mapa para hacer zoom, desplazarse y establecer la posición exacta.",
      map_label: "Mapa:",
      note: "Las coordenadas precisas mejoran los análisis y los mapas.",
    },
    profile: {
      cadastre_help: "Identificador de registro opcional (máximo 24 caracteres).",
      cadastre_label: "Árbol Catastro No:",
      heading: "Perfil del árbol",
      name_help: "Nombre legible por humanos (máximo 40 caracteres).",
      name_label: "Nombre:",
      note: "Puede editarlos más adelante en los detalles del árbol.",
    },
    represent: {
      heading: "Árbol representativo",
      help: "Opcionalmente, declare que este árbol representa otros (agrupación).",
    },
    sensors: {
      heading: "Sensores",
      help: "Asigne sensores TreeSense existentes a este árbol o elimine asignaciones.",
      note: "Las asignaciones de sensores también se pueden cambiar más adelante en el detalle del árbol.",
    },
    soil: {
      heading: "Suelo",
      max_f_help: "Valor típico, por ejemplo, 45.",
      max_f_label: "Capacidad de campo (max_f):",
      max_nf_help: "Valor típico, por ejemplo, 25.",
      max_nf_label: "Máx. agua disponible (max_nf):",
      note: "Solo es necesario si trabaja con estimaciones de suelo-agua.",
      pwp_help: "Punto de marchitez permanente (p. ej., 10).",
      pwp_label: "PWP:",
    },
  },
  tree_health: "Salud de los árboles",
  tree_info: "Información del árbol",
  tree_info_help: {
    description:
      "Esta pestaña muestra los datos maestros del árbol seleccionado (especie, dimensiones, ubicación y estado). Proporciona contexto para las lecturas de los sensores y el historial de mantenimiento.",
    fields: {
      dimensions_help:
        "Altura, diámetro de copa y circunferencia del tronco según los últimos registros (valores de inventario).",
      dimensions_label: "Dimensiones:",
      location_help:
        "Latitud/longitud WGS84 utilizada para colocar el árbol en el mapa. La precisión depende de los datos subyacentes del inventario.",
      location_label: "Ubicación / coordenadas:",
      species_help: "Nombre científico (y nombre común si está disponible).",
      species_label: "Especies:",
      status_help:
        "Evaluación actual (por ejemplo, sin estrés por sequía / estrés por sequía). Dependiendo de la configuración del proyecto, esto puede derivarse de datos de sensores o de una evaluación manual.",
      status_label: "Estado del árbol:",
      year_phase_help:
        "Año de plantación (puede estimarse) y fase del ciclo de vida, como la fase de establecimiento, desarrollo o envejecimiento.",
      year_phase_label: "Año y fase de siembra:",
    },
    fields_heading: "Explicaciones de campo",
    heading: "lo que ves aquí",
    note: "Consejo: Puede editar datos maestros mediante el icono de lápiz si tiene los permisos necesarios.",
  },
  tree_inventory: "Inventario de árboles",
  tree_management_mode: "Modo de gestión de árboles",
  tree_name: "Nombre del árbol",
  tree_phases: "Fases del árbol",
  tree_photos: "Fotos de Arbol",
  tree_profile: {
    learn_more: "Haga clic aquí para obtener más información",
    tree_info: "Información del árbol",
    tree_species: "Datos interesantes",
    tree_species_knowledge: "Hechos",
  },
  tree_species: "Especies de árboles",
  tree_stakes_control: "Control de estacas de árboles",
  tree_status: "Estado del árbol",
  tree_water_deficit: "Déficit de agua de los árboles",
  tree_water_stress: "Estrés hídrico",
  tree_wiki: "Wiki Árboles",
  tree_with_sensor: "Árbol con Sensor",
  tree_without_sensor: "Árbol sin Sensor",
  treegenus: "Género de árbol",
  trees: "Árboles",
  trees_short: "Árboles",
  trees_views: "Árboles",
  treespecies: "Especies de árboles",
  trunk_circumference: "Circunferencia del tronco",
  trunk_defects: "Defectos del tronco",
  trunk_protection: "Protección del maletero",
  type: "Tipo",
  type_an_adress: "Escribe una dirección",
  type_of_maintenance: "Tipo de mantenimiento",
  unable_to_upload_file: "No se puede cargar el archivo",
  unknown: "Desconocido",
  update: "Actualizar",
  update_customer_logo_description: "Cargue y actualice el logotipo de su organización",
  update_image: "Actualizar imagen",
  upload: "Subir",
  upload_3d_model: "Subir modelo 3D",
  upload_file: "Subir archivo",
  upload_leaf_img: "Cargar imagen de hoja",
  upload_tree: "Subir árbol",
  upload_tree_img: "Subir imagen de árbol",
  use_my_location: "Usar mi ubicación",
  use_new_moisture_formula: "Usar nueva fórmula",
  user: "Usuario",
  user_details: {
    empty_project: "Usuario vacío, comience a agregar árboles.",
    no_user_selected: "Por favor seleccione usuario para ver detalles",
  },
  user_form: {
    address: "DIRECCIÓN",
    areas: "Áreas de riego",
    basic_info: "Información básica",
    login_credentials: "Credenciales de inicio de sesión",
    profile: "Perfil",
  },
  user_invitation_email_hint:
    "Después de guardar, el usuario recibirá un correo electrónico para establecer su propia contraseña.",
  username: "Nombre de usuario",
  users: "Usuarios",
  validation: {
    all_address_field_are_required: "Todos los campos de dirección son obligatorios",
    cadastre_or_name_required:
      "Se debe proporcionar el número de catastro del árbol o el nombre del árbol.",
    either_field_required: "* Al menos uno de estos campos es obligatorio.",
    email_is_required: "Se requiere correo electrónico",
    hardware_serial_is_required: "Se requiere serie de hardware",
    hardware_serial_must_be_16_characters:
      "El número de serie del hardware debe tener exactamente 16 caracteres.",
    imei_must_be_15_digits: "El IMEI debe tener exactamente 15 dígitos.",
    invalid_email_address: "Dirección de correo electrónico no válida",
    invalid_hex_identifier:
      "El identificador debe ser un valor hexadecimal en mayúscula válido. Utilice únicamente los dígitos del 0 al 9 y las letras mayúsculas de la A a la F.",
    invalid_house_number: "Número de casa no válido",
    must_be_a_number: "El valor debe ser un número.",
    name_is_required: "El nombre es obligatorio",
    out_of_range: "Value must be between {{min}} and {{max}}",
    password_is_required: "Se requiere contraseña",
    position_is_required: "Se requiere posición",
    project_name_required: "El nombre del proyecto es obligatorio",
    project_name_max_length: "El nombre del proyecto no debe exceder 100 caracteres",
    project_start_required: "El inicio del proyecto es obligatorio",
    area_required: "El área es obligatoria",
    required_fields: "* Campos obligatorios",
    sensor_limit_exceeded_for_your_package: "Se excedió el límite del sensor para su paquete",
    task_error: "Se requiere tarea.",
    tree_limit_exceeded_for_your_package: "Se excedió el límite de árboles para su paquete",
    user_limit_exceeded_for_your_package: "Límite de usuarios excedido para su paquete",
    user_with_this_email_already_exist: "El usuario con este correo electrónico ya existe",
  },
  value: "Valor",
  variables: "variables",
  view_calendar: "Calendario",
  view_kanban: "Kanban",
  view_list: "Lista",
  view_on_chart: "Abierto en ciencia de datos",
  view_on_list: "Abrir en lista",
  view_on_map: "Abrir en el mapa",
  viewproject: "Ver proyecto",
  views_per_page: "Ver por página",
  vitality_stage: "Etapa de vitalidad",
  vitality_stage_help:
    "0 = Vital, 1 = Ligeramente debilitado, 2 = Debilitado, 3 = Severamente debilitado",
  vta_assessments: "Evaluaciones VTA",
  water_soil: "Humedad del suelo",
  water_stress: "Estrés hídrico",
  weather: "Clima",
  weekly_summary_email: "Correo electrónico de resumen semanal",
  welcome_back: "¡Bienvenido de nuevo!",
  wiki_help: "Wiki y guías",
  with_sensor: "Con sensor",
  without_location: "Sin Ubicación",
  without_project: "Sin proyecto",
  without_sensor: "Sin sensor",
  working: "Laboral",
  write_some_notes_on_action_performed: "Escribe algunas notas sobre la acción realizada...",
  write_something: "Escribe algo...",
  years_short: "años",
  zip_code: "Código postal",
  zoom_in: "Dar un golpe de zoom",

  // NB-IoT sensor configuration
  weekly_signal_avg: "Intensidad de señal (prom. 7d)",
  signal_strength: "Señal",
  signal_low: "Baja",
  signal_medium: "Media",
  signal_high: "Alta",
  signal_strength_info:
    "La intensidad de la señal afecta la vida de la batería. Una señal baja consume más batería, una señal media consume más que una alta, y una señal alta es la más eficiente.",
  signal_no_data: "Sin datos",
  send_interval: "Intervalo de envío",
  measurement_interval: "Intervalo de medición",
  send_configuration: "Enviar configuración",
  downlink_queued: "Configuración en cola para el próximo enlace ascendente",
  downlink_failed: "Error al poner en cola la configuración",
  confirm_send_downlink: "¿Está seguro de que desea enviar la configuración al sensor?",
  no_intervals_configured: "No hay intervalos configurados",
  interval_5min: "5 minutos",
  interval_10min: "10 minutos",
  interval_15min: "15 minutos",
  interval_30min: "30 minutos",
  interval_1h: "1 hora",
  interval_2h: "2 horas",
  interval_4h: "4 horas",
  interval_6h: "6 horas",
  interval_12h: "12 horas",
  interval_24h: "24 horas",

  // Irrigation Export
  irrigation_export_title: "Exportar plan de riego",
  irrigation_export_button: "Exportar",
  yes: "Sí",
};
